import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var SplitOrderIA = function SplitOrderIA(_ref) {
  var context = _ref.context;
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "B7GCRh",
    defaultMessage: [{
      "type": 0,
      "value": "Het opsplitsen van een bestelling is handig als je de specificaties voor sommige producten moet aanpassen, maar geen artikelen wilt nabestellen tot een nieuwe datum. Zo splits je een bestelling op:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "doQrD2",
    defaultMessage: [{
      "type": 0,
      "value": "1. Ga naar de pagina met "
    }, {
      "children": [{
        "type": 0,
        "value": "bestelgegevens"
      }],
      "type": 8,
      "value": "OrderLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      OrderLinkFormatting: function OrderLinkFormatting(chunks) {
        var _context$brandOrder, _context$brandOrder$b;
        return _OrderLinkFormatting(chunks, (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "9rbh3V",
    defaultMessage: [{
      "type": 0,
      "value": "2. Selecteer daar de optie "
    }, {
      "children": [{
        "type": 0,
        "value": "Opsplitsen"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". Die vind je meestal aan de rechterkant."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "+ArNhy",
    defaultMessage: [{
      "type": 0,
      "value": "3. Je ziet alle producten en de hoeveelheid ervan in de bestelling. Geef hier de hoeveelheden op die je naar een nieuwe bestelling wilt verplaatsen."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zCnJLL",
    defaultMessage: [{
      "type": 0,
      "value": "4. Selecteer "
    }, {
      "children": [{
        "type": 0,
        "value": "Nieuwe bestelling aanmaken"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " nadat je je keuzes hebt gemaakt."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GWvkwO",
    defaultMessage: [{
      "type": 0,
      "value": "Beide bestellingen hebben hetzelfde verzendadres en dezelfde verwachte verzenddatum, maar de nieuwe bestelling heeft een uniek merkbestelnummer."
    }]
  })));
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};